"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KINDS = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next12_components_input_1 = __importStar(require("@gcloud-npm/next12.components.input"));
const next12_components_simple_form_1 = __importDefault(require("@gcloud-npm/next12.components.simple-form"));
const next12_components_beach_1 = __importDefault(require("@gcloud-npm/next12.components.beach"));
const next12_components_text_info_1 = __importDefault(require("@gcloud-npm/next12.components.text-info"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_main_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer");
const SEARCH_INPUT = "buscar";
const ATENCION_CLIENTE = "https://atencionalcliente.movistar.es/";
exports.KINDS = {
    E404: "404",
    E500: "500",
};
//
const TEXTS = {
    [exports.KINDS.E404]: {
        TITLE: "404",
        SMS: "Lo sentimos esta página no existe",
    },
    [exports.KINDS.E500]: {
        TITLE: "500",
        SMS: "Upss, ha ocurrido un error",
    },
};
const ErrorScreen = ({ kind = "404" }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleSumit = (evt) => {
        try {
            const query = document.getElementById(SEARCH_INPUT).value;
            if (evt) {
                evt.preventDefault();
            }
            const urlToRedirect = `${ATENCION_CLIENTE}?q=${query}`;
            window.location.href = urlToRedirect;
        }
        catch (err) {
            dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda({
                error: err,
                kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
                processName: "handleSearch",
                filePath: "components/SupportAndSearch",
            }));
        }
    };
    const CURRENT_TEXTS = TEXTS[kind];
    return (react_1.default.createElement(next12_components_beach_1.default, null,
        react_1.default.createElement(next12_components_text_info_1.default, { size: "display02", fontType: "font-light", color: "white", align: "center", display: "block", text: CURRENT_TEXTS.TITLE, cySelector: CURRENT_TEXTS.TITLE }),
        react_1.default.createElement(next12_components_text_info_1.default, { size: "title045", color: "white", align: "center", display: "block", fontType: "font-light", text: CURRENT_TEXTS.SMS }),
        react_1.default.createElement(next12_components_simple_form_1.default, { onSubmit: handleSumit },
            react_1.default.createElement("div", { className: "inputGap", style: {
                    paddingTop: "1rem",
                } },
                react_1.default.createElement(next12_components_input_1.default, { id: SEARCH_INPUT, theme: next12_components_input_1.THEME.ROUNDED, colorTheme: next12_components_input_1.COLOR_THEME.WHITE, placeHolder: "\u00BFQu\u00E9 est\u00E1s buscando?", taggingInfo: {
                        componentName: "Error-404",
                        componentVariation: "all",
                        componentProduct: "",
                        componentContent: "",
                    } })))));
};
ErrorScreen.propTypes = {
    kind: prop_types_1.default.oneOf([exports.KINDS.E404, exports.KINDS.E500]),
};
ErrorScreen.defaultProps = {
    kind: exports.KINDS.E404,
};
exports.default = ErrorScreen;
//# sourceMappingURL=index.js.map